/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import TransferFunds from './TrasferFunds';
import { hot } from 'react-hot-loader';

export default hot(module)(function Heading(props) {
	return (
		<div className="form-group row">
			<div className="col-sm-6">
				<h4>Funding Source List</h4>
			</div>
			<div className="col-sm-6">
				<TransferFunds
					balance={props.balance}
					customer_id={props.customer_id}
					reloadBalance={props.reloadBalance}
				/>
			</div>
		</div>
	);
});
